import { render, staticRenderFns } from "./shouruWay.vue?vue&type=template&id=5f16c4ad&scoped=true&"
import script from "./shouruWay.vue?vue&type=script&lang=js&"
export * from "./shouruWay.vue?vue&type=script&lang=js&"
import style0 from "./shouruWay.vue?vue&type=style&index=0&id=5f16c4ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16c4ad",
  null
  
)

export default component.exports